import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub, FaCode } from 'react-icons/fa'
import { IconContext } from "react-icons";

const HeaderSocials = () => {
  return (
    <div className="header__socials">

      <IconContext.Provider value={{ className: "shared-class", size: 30 }}>
        <a href="https://www.linkedin.com/in/tejas-patne/" target="_blank" title='linkedin profile'><BsLinkedin /></a>
        <a href="https://github.com/TejasPatne" target="_blank" title='github profile'><FaGithub /></a>
        <a href="https://leetcode.com/u/TejasPatne/" target="_blank" title='leetcode profile'><FaCode /></a>
      </IconContext.Provider>
    </div>
  )
}

export default HeaderSocials